import { forwardRef, type ComponentProps } from "react";
import { cn } from "@/utils/cn";
import { fieldControlClass } from "./field-styles";

export const Textarea = forwardRef<HTMLTextAreaElement, ComponentProps<"textarea">>(({ className, ...props }, ref) => (
  <textarea ref={ref} data-slot="textarea" className={cn(fieldControlClass, "min-h-24 px-3 py-2", className)} {...props} />
));
Textarea.displayName = "Textarea";
